import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const estadosEvaluacionesApi = createApi({
  reducerPath: "estadosEvaluacionesApi",
  baseQuery: customFetchBase,
  tagTypes: ["Estados Evaluaciones"],
  endpoints: () => ({}),
});
